import React from 'react';
import BaseComponent from 'meta/features/base-component';
import cn from 'classnames';
import './style.less';
import AlertCloseButton from './AlertCloseButton';
/** Displays a single message to the user. */
class Alert extends BaseComponent {
    static defaultProps = {
        type: 'info',
        closable: true,
        count: 1
    };
    render() {
        let { title, message, children, type, className, onClose, count, closable, closeButtonText } = this.props;
        let _className = cn('alert', `alert-${type}`, 'ui2-alert', className);
        return (<div className={_className}>
                {count > 1 ? <div className="alertsCount">{count}</div> : ''}
                <strong>{title}</strong>&nbsp;{message || children}
                {closable ? (<AlertCloseButton text={closeButtonText} onClose={onClose}/>) : ""}
                
            </div>);
    }
}
export default Alert;
